import React from 'react';
import './style.css';
const Box = props => (
  <div
    className="div__Box"
    style={{...props.style, border: props.outline ? 'solid 2px var(--MAGNESIUM)' : 'none' }}
  >
    {props.children}
  </div>
);

export default Box;
